<template>
  <div id="header">
    <div class="logo">
      <a href="/#/">
        <img src="~@/common/imgs/logo.png">
      </a>
    </div>
    <div class="phone-nav" @click="isClose">
      <i class="el-icon-close" v-if="isShow"></i>
      <i class="el-icon-s-fold" v-else></i>
    </div>
    <div :class="{'menu-list': true,'menu-show': isShow}">
      <ul>
        <li class="menu" v-for="menu in menuData" :key="menu.id">
          <router-link :to="menu.url">{{menu.name}}</router-link>
          <div class="nav-list" v-show="menu.children.length > 0">
            <router-link :to="nav.url" class="nav" v-for="nav in menu.children" :key="nav.id">{{nav.name}}</router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        isShow: false,
        menuData: [{
            id: '1',
            name: '首页',
            url: '/',
            children: []
          },
          {
            id: '2',
            name: '集团介绍',
            url: 'Intro',
            children: [{
              id: '2.1',
              name: '企业简介',
              url: 'Intro'
            }, {
              id: '2.2',
              name: '企业架构',
              url: 'Architecture'
            }, {
              id: '2.3',
              name: '企业文化',
              url: 'Culture'
            }, {
              id: '2.4',
              name: '发展历程',
              url: 'DevelopmentCourse'
            }, {
              id: '2.5',
              name: '社会责任',
              url: 'Responsibility'
            }]
          },
          {
            id: '3',
            name: '荣誉资质',
            url: "HonorMention?id=1",
            children: [{
              id: '3.1',
              name: '企业资质',
              url: 'HonorMention?id=1'
            }, {
              id: '3.2',
              name: '企业荣誉',
              url: 'HonorMention?id=2'
            }, {
              id: '3.3',
              name: '工程荣誉',
              url: 'PjHonor'
            }]
          },
          {
            id: '4',
            name: '业绩展示',
            url: 'ShowGrades?id=5',
            children: [{
              id: '4.1',
              name: '医疗建筑',
              url: 'ShowGrades?id=5'
            }, {
              id: '4.2',
              name: '幕墙、门窗',
              url: 'ShowGrades?id=6'
            }, {
              id: '4.3',
              name: '商业空间',
              url: 'ShowGrades?id=7'
            }, {
              id: '4.4',
              name: '文化建筑',
              url: 'ShowGrades?id=8'
            }, {
              id: '4.5',
              name: '办公行政空间',
              url: 'ShowGrades?id=9'
            }, {
              id: '4.6',
              name: '交通场站',
              url: 'ShowGrades?id=10'
            }, {
              id: '4.7',
              name: '酒店及会所',
              url: 'ShowGrades?id=11'
            }, {
              id: '4.8',
              name: '住宅精装修',
              url: 'ShowGrades?id=12'
            }, {
              id: '4.9',
              name: '金融场所',
              url: 'ShowGrades?id=13'
            }, {
              id: '4.10',
              name: '机电安装工程',
              url: 'ShowGrades?id=14'
            }, {
              id: '4.11',
              name: '电子及智能化工程',
              url: 'ShowGrades?id=15'
            }]
          },
          {
            id: '5',
            name: '技术创新',
            url: 'IndustrialPark',
            children: [{
              id: '5.1',
              name: '深汕产业园',
              url: 'IndustrialPark'
            }]
          },
          {
            id: '6',
            name: '视频中心',
            url: 'CoVideos',
            children: [{
                id: '6.1',
                name: '企宣片',
                url: 'CoVideos'
              },{
                id: '6.2',
                name: '项目片',
                url: 'PjVideos'
              },{
                id: '6.3',
                name: '活动片',
                url: 'AcVideos'
              }]
          }, {
            id: '7',
            name: '人才招聘',
            url: 'Talent',
            children: []
          },
          {
            id: '8',
            name: '联系我们',
            url: 'ShenZhen',
            children: [
              {
                id: '8.1',
                name: '深圳总部',
                url: 'ShenZhen'
              },{
                id: '8.2',
                name: '深汕合作区',
                url: 'ShenShan'
              }
            ]
          }
        ]
      }
    },
    methods: {
      isClose(){
        this.isShow = !this.isShow;
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/Header.vue